var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91675 8.3337C1.83679 8.81011 1.16675 9.47401 1.16675 10.2083C1.16675 11.6581 3.77842 12.8333 7.00008 12.8333C10.2217 12.8333 12.8334 11.6581 12.8334 10.2083C12.8334 9.47401 12.1634 8.81011 11.0834 8.3337M10.5001 4.66666C10.5001 7.03715 7.87508 8.16666 7.00008 9.91666C6.12508 8.16666 3.50008 7.03715 3.50008 4.66666C3.50008 2.73366 5.06708 1.16666 7.00008 1.16666C8.93308 1.16666 10.5001 2.73366 10.5001 4.66666ZM7.58342 4.66666C7.58342 4.98882 7.32225 5.24999 7.00008 5.24999C6.67792 5.24999 6.41675 4.98882 6.41675 4.66666C6.41675 4.34449 6.67792 4.08332 7.00008 4.08332C7.32225 4.08332 7.58342 4.34449 7.58342 4.66666Z",
    stroke: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.41edb6287d7bd53da5c96b3fc16054b8.svg";
export { ForwardRef as ReactComponent };